import CanvasDrawing from './CanvasDrawing';

export default CanvasDrawing;
